import React, { Component } from "react";
import "../css/EnlargeGallery.css";
import { connect } from "react-redux";
import { enlargeImage } from "../models";

class EnlargeGallery extends Component {
  render() {
    const { enlargeActive, enlargeImageUrl, closeEnlargeImage } = this.props;
    return (
      <div
        className={`enlarge-content ${
          enlargeActive ? "enlarge-content-active" : ""
        }`}
      >
        <div className="enlarge-close-btn" onClick={closeEnlargeImage()} />
        <div className="enlarge-img-layout">
          {enlargeActive ? (
            <img src={enlargeImageUrl.displayUrl} alt="" />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    enlargeActive: state.enlargeImage.enlargeActive,
    enlargeImageUrl: state.enlargeImage.enlargeImageUrl
  };
};
const mapDispatchToProps = () => {
  return {
    closeEnlargeImage: () => enlargeImage.actions.closeEnlargeImage
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EnlargeGallery);
